export * from './home.component';



// WEBPACK FOOTER //
// /home/thunder/git/portfolier/src/app/home/index.ts